module.exports = function getResource(label, vars = []) {
    let resources = {
        sortDescribedBy: 'À la sélection de l’option de filtre, les produits affichés seront automatiquement mis à jour pour correspondre à l’option de filtre choisie.',
        filterDescribedBy: 'À la sélection de l’option de filtre, les produits affichés seront automatiquement mis à jour pour correspondre à l’option de filtre choisie. Pour supprimer un filtre, cliquer sur le bouton « Réinitialiser » ou « Réinitialiser tous les filtres ».',
        categoryNavigation: 'Navigation - Catégorie',
        brandNavigation: 'Navigation - Marque',
        searchNavigation: 'Navigation - Recherche',
        exploreTheBrand: 'Découvrir la marque',
        oneProduct: '1 produit',
        result: 'résultat',
        results: 'résultats',
        products: 'produits',
        alternativeKeyword: `Nous n’avons pas trouvé de correspondance exacte pour « ${vars[0]} » et avons suggéré « ${vars[1]} » comme solution de rechange possible.`,
        tooManyProducts: `Le nombre de produits dépasse ${vars[0]} articles – veuillez utiliser la pagination pour voir tous les produits.`
    };
    return resources[label];
};
